// @flow
import authApiService from './auth-api-service';
import type { RecordFileType } from '../types/file';

export class RecordFileService {
  all(recordId: number): Promise<RecordFileType[]> {
    return authApiService.get(`/resources/${recordId}/files`)
      .then((result) => result.files);
  }

  show(fileId: number): Promise<RecordFileType> {
    return authApiService.get(`/files/${fileId}`)
      .then((result) => result.file);
  }

  viewThumbnail(fileId: number): Promise<Blob> {
    return authApiService.get(`/resources/files/${fileId}/thumb/`, {
      responseType: 'blob'
    })
      .then((response) => new Blob([response], {
        type: response.type
      }));
  }

  viewPreview(fileId: number): Promise<Blob> {
    return authApiService.get(`/files/${fileId}/preview`, {
      responseType: 'blob'
    })
      .then((response) => new Blob([response], {
        type: response.type
      }));
  }

  view(fileId: number): Promise<Blob> {
    return authApiService.get(`/resources/files/${fileId}/view`, {
      responseType: 'blob'
    })
      .then((response) => new Blob([response], {
        type: response.type
      }));
  }
}

export default new RecordFileService();



// WEBPACK FOOTER //
// ./src/services/record-file-service.js